/**
 * useEmployees — React Query hook az összes HR dolgozó lekérdezéséhez
 */

import { useQuery } from '@tanstack/react-query';
import { listEmployees, type Employee } from '../api/hr-api';

export const employeesQueryKey = ['hr', 'employees'] as const;

export function useEmployees() {
  return useQuery<Employee[]>({
    queryKey: employeesQueryKey,
    queryFn: async () => {
      const res = await listEmployees();
      return res.data;
    },
    staleTime: 60_000,
  });
}
